import { makeStyles } from 'src/utils/makeStyles';

export default makeStyles({
  box: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    minHeight: { tablet: '640px' },
  },
  boxUpdatedStyles: {
    padding: 3,
  },
  boxOldStyles: {
    width: { tablet: '760px' },
    padding: { tablet: '24px 40px 40px' },
  },
  heading: {
    marginBottom: '12px',
  },
  body: {
    flexGrow: 1,
    marginBottom: '48px',
  },
  button: {
    marginRight: '10px',
    paddingLeft: '48px',
    paddingRight: '48px',
  },
  certificateList: {
    marginTop: 4,
    marginBottom: 2,
  },
  footer: {
    marginTop: 'auto',
  },
  loaderBox: {
    alignItems: 'center',
    justifyContent: 'space-evenly',
  },
});
